import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable, isObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { ReceptorFactura, validarReceptor } from "./receptorfactura";
import { obtenerComponenteDireccionColonia } from "app/features/componentes/direccioncolonia";
import { Observable } from "rxjs/Observable";
import { DireccionSelector, DireccionSelectorElement } from "app/features/selectores/index";


const DireccionColoniaCompNoRX = obtenerComponenteDireccionColonia<models.Factura>("IdColonia", "Direccion", "Dirección");
export const DireccionColoniaComp = componentToRx(DireccionColoniaCompNoRX);

type Entity = models.Factura;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    soloLectura: boolean;
}

export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        ReceptorFactura: validation.subrule(validarReceptor),
        IdCliente: validation.required,
        Serie: validation.required,
        Folio: validation.required,
        ClaveSatRegimenFiscalEmisor: validation.required,
        ClaveSatUsoReceptor: validation.required,
        ClaveSatMoneda: validation.required,
        TipoCambio: validation.required,
    };
    return validation.getErrors(rules, x);
}

/**
* Componente auxiliar para mostrar la parte del receptor de las facturas
*/
export class AuxiliarReceptorNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    idCliente = (props: Props) => props.value.IdCliente;
    esFacturadaOnline = (props: Props) => props.value.Origen == models.OrigenFactura.FacturacionOnline;

    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    private onHandleClienteChange = async (idCliente: number) => {
        const viejo = this.props.value;
        const cambioCliente: Partial<Entity> = { IdCliente: idCliente, };
        this.props.onChange({ ...viejo, ...cambioCliente });

        var datosCliente = await resources.Cliente.ObtenerDatosFacturaCliente(idCliente);
        const nuevo = this.props.value;
        const cambio: Partial<Entity> = {
            ReceptorFactura: datosCliente.ReceptorFactura,
            NoCuentaOrdenante: datosCliente.NoCuentaOrdenante,
            Direccion:datosCliente.Direccion,
            IdColonia: datosCliente.IdColonia
        };
        this.props.onChange({ ...nuevo, ...cambio });
    }

    private cliente = createSelectorRx(this.idCliente, id => {
        const ret = id != null ? observeResource(resources.Cliente.getMemo, id) : null;
        return toObservable(ret);
    });

    private direcciones = createSelectorRx(this.cliente, (cli) => (cli && cli.Direcciones) || []);
    private direccionesSelect = createSelectorRx(this.direcciones, direcciones => {
        return direcciones.map<DireccionSelectorElement>(x => ({ id: x.IdRegistro, view: x.Direccion }));
    });

    render() {
        var { value, soloLectura } = this.props;
        const Receptor = this.getField(ReceptorFactura);
        const Cliente = this.getField(selectores.Cliente);
        const Direccion = this.getField(selectores.DireccionSelector);

        const direcciones = this.direccionesSelect(this.props);
        const esfacturadaOnline = this.esFacturadaOnline(this.props);

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <span>
                        <i className="fa fa-" />
                        Receptor
                    </span>
                </div>
                <div className="panel-body">
                    {kea.autogrid(12, [
                        <Cliente field="IdCliente" label="Cliente:" onChange={this.onHandleClienteChange} readonly={soloLectura} />,
                        //Descomentar cuando se decidan las direcciones de facturaciòn del cliente
                        <DireccionColoniaComp value={this.props.value} onChange={this.props.onChange} readonly={soloLectura} />
                    ])}
                    <Receptor field="ReceptorFactura" readonly={soloLectura} />
                </div>
            </div>
        );
    }
}

export const AuxiliarReceptor = componentToRx(AuxiliarReceptorNoRx);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/componentes/auxiliarreceptor.tsx